module.exports = __webpack_public_path__ + "media/智慧社区-智慧物业.9ac8058e.mp4";